import { useCallback, useContext, useState } from 'react'
import { useCommonServices, useExperimentService } from '../services'
import { isEligibleForTrial } from '@lib/helpers/trial-cta'
import { PageContext } from '@contexts/page-context'
import { gnarSpec } from '@lib/tracking/gnar'

export interface UseToolsLtvNav {
  isLtvNavExperiment: boolean
  isTrialEligible: boolean
  shouldShowUpgradeCopy: boolean
  ctaText: string
  description: string
  trackShow: () => void
}

export const useToolsLtvNav = (): UseToolsLtvNav => {
  const { facadeService } = useCommonServices()
  const { specialOffers } = facadeService.get()
  const { getToolsLtvNavAssignment } = useExperimentService()
  const { pageId, slug } = useContext(PageContext)

  const [isLtvNavExperiment] = useState(() => getToolsLtvNavAssignment() === 'test')
  const isTrialEligible = isEligibleForTrial(specialOffers)
  const shouldShowUpgradeCopy = isLtvNavExperiment && !isTrialEligible

  const ctaText = shouldShowUpgradeCopy ? 'Get Grammarly Pro' : 'Try Grammarly Pro for free'

  const description = shouldShowUpgradeCopy
    ? "You've reached your daily free limit. Upgrade to Pro to get full access to Grammarly."
    : "You've reached your daily free limit. Start your free trial today to get full access to Grammarly."

  const trackShow = useCallback(() => {
    if (isLtvNavExperiment) {
      const variation = shouldShowUpgradeCopy ? 'modal_trial_ineligible' : 'modal_trial_eligible'
      gnarSpec.cmsPersonalizedContentComponentShow(pageId, slug, 'tools_ltv_nav_expanded', variation)
    }
  }, [isLtvNavExperiment, shouldShowUpgradeCopy, pageId, slug])

  return {
    isLtvNavExperiment,
    isTrialEligible,
    shouldShowUpgradeCopy,
    ctaText,
    description,
    trackShow,
  }
}
